export var Status;
(function (Status) {
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Event is scheduled to happen or has happened. */
    Status["CONFIRMED"] = "CONFIRMED";
    /** DEPRECATED! AND WILL BE REMOVED SOON */
    Status["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
    /** Event has been canceled. */
    Status["CANCELLED"] = "CANCELLED";
})(Status || (Status = {}));
export var RecurrenceType;
(function (RecurrenceType) {
    RecurrenceType["UNKNOWN_RECURRENCE_TYPE"] = "UNKNOWN_RECURRENCE_TYPE";
    /** The event occurs only once and doesn't repeat. */
    RecurrenceType["NONE"] = "NONE";
    /** Defines the recurrence pattern for a series of recurring events. */
    RecurrenceType["MASTER"] = "MASTER";
    /** A specific occurrence of a recurring event. You can't create an event with `{"recurrenceType": "INSTANCE"}`, instead it's automatically generated based on the recurrence rule. If you update an `INSTANCE` event, `recurrenceType` automatically changes to `EXCEPTION`. */
    RecurrenceType["INSTANCE"] = "INSTANCE";
    /** A modified instance of a recurring event that differs from the recurrence pattern. For example, an event with a different time or location. You can't create an `EXCEPTION` event directly, instead it's set automatically when you update an `INSTANCE` event. */
    RecurrenceType["EXCEPTION"] = "EXCEPTION";
})(RecurrenceType || (RecurrenceType = {}));
export var Frequency;
(function (Frequency) {
    Frequency["UNKNOWN_FREQUENCY"] = "UNKNOWN_FREQUENCY";
    /** The event's recurrence pattern is based on weeks. */
    Frequency["WEEKLY"] = "WEEKLY";
})(Frequency || (Frequency = {}));
export var Day;
(function (Day) {
    /** The recurring event takes place on Mondays. */
    Day["MONDAY"] = "MONDAY";
    /** The recurring event takes place on Tuesdays. */
    Day["TUESDAY"] = "TUESDAY";
    /** The recurring event takes place on Wednesday. */
    Day["WEDNESDAY"] = "WEDNESDAY";
    /** The recurring event takes place on Thursdays. */
    Day["THURSDAY"] = "THURSDAY";
    /** The recurring event takes place on Fridays. */
    Day["FRIDAY"] = "FRIDAY";
    /** The recurring event takes place on Saturdays. */
    Day["SATURDAY"] = "SATURDAY";
    /** The recurring event takes place on Sundays. */
    Day["SUNDAY"] = "SUNDAY";
})(Day || (Day = {}));
export var Transparency;
(function (Transparency) {
    Transparency["UNKNOWN_TRANSPARENCY"] = "UNKNOWN_TRANSPARENCY";
    /** The schedule is blocked during the event, preventing other events that involve the same entities (for example, Booking staff members) from being scheduled at the same time. */
    Transparency["OPAQUE"] = "OPAQUE";
    /** The schedule remains open during the event, allowing other events to be scheduled concurrently. */
    Transparency["TRANSPARENT"] = "TRANSPARENT";
})(Transparency || (Transparency = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    /** The event is held at a business location. */
    LocationType["BUSINESS"] = "BUSINESS";
    /** The event is held at the customer's location, such as their home or office. */
    LocationType["CUSTOMER"] = "CUSTOMER";
    /** The event is held at an address or venue not tied to the business or customer. */
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
export var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Full read and write access. */
    Role["WRITER"] = "WRITER";
    /** Full read access, write access limited to `event.notes`. */
    Role["COMMENTER"] = "COMMENTER";
})(Role || (Role = {}));
export var ParticipantsStatus;
(function (ParticipantsStatus) {
    ParticipantsStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** All participants are confirmed. */
    ParticipantsStatus["CONFIRMED"] = "CONFIRMED";
    /** At least one participant isn't confirmed yet. */
    ParticipantsStatus["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
})(ParticipantsStatus || (ParticipantsStatus = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["ZOOM"] = "ZOOM";
    Type["CUSTOM"] = "CUSTOM";
})(Type || (Type = {}));
export var Field;
(function (Field) {
    Field["UNKNOWN_FIELD"] = "UNKNOWN_FIELD";
    /** `title` is inherited from the schedule or `MASTER` event. */
    Field["TITLE"] = "TITLE";
    /** `timeZone` is inherited from the schedule or `MASTER` event. */
    Field["TIME_ZONE"] = "TIME_ZONE";
    /** `start` and `end` are inherited from the `MASTER` event. */
    Field["TIME"] = "TIME";
    /** `location` is inherited from the schedule or `MASTER` event. */
    Field["LOCATION"] = "LOCATION";
    /** `resources` is inherited from the `MASTER` event. */
    Field["RESOURCES"] = "RESOURCES";
    /** `capacity` is inherited from the schedule or `MASTER` event. */
    Field["CAPACITY"] = "CAPACITY";
    /** `participants` is inherited from the `MASTER` event. */
    Field["PARTICIPANTS"] = "PARTICIPANTS";
    /** `conferencingDetails` is inherited from the schedule or `MASTER` event. */
    Field["CONFERENCING_DETAILS"] = "CONFERENCING_DETAILS";
})(Field || (Field = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["WIX_USER"] = "WIX_USER";
})(IdentityType || (IdentityType = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ResolutionMethod;
(function (ResolutionMethod) {
    ResolutionMethod["QUERY_PARAM"] = "QUERY_PARAM";
    ResolutionMethod["SUBDOMAIN"] = "SUBDOMAIN";
    ResolutionMethod["SUBDIRECTORY"] = "SUBDIRECTORY";
})(ResolutionMethod || (ResolutionMethod = {}));
export var RequestedFields;
(function (RequestedFields) {
    RequestedFields["UNKNOWN_REQUESTED_FIELDS"] = "UNKNOWN_REQUESTED_FIELDS";
    /** Returns all fields with personal data. Your app must have `Read Calendars - Including PI` or `Manage Calendars` permission scope. */
    RequestedFields["PI_FIELDS"] = "PI_FIELDS";
    /** Returns only fields containing your own personal data. */
    RequestedFields["OWN_PI_FIELDS"] = "OWN_PI_FIELDS";
})(RequestedFields || (RequestedFields = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map